import { Component, forwardRef, ChangeDetectionStrategy, Inject, Injector, ChangeDetectorRef, Optional, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbpValidationDisplayConstant, AbpValidationDisplayModule } from '@colibrium/abp-validation-display';
import { ControlBase } from '@colibrium/abp-form-control-base';
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@colibrium/abp-label';
import * as ɵngcc3 from '@colibrium/abp-validation-display';

function AbpTextBoxControlComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelement(2, "abp-field-display-label", 2);
    ɵngcc0.ɵɵelementStart(3, "input", 3, 4);
    ɵngcc0.ɵɵlistener("change", function AbpTextBoxControlComponent_ng_container_0_Template_input_change_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.onInputChange($event.target.value); })("keyup", function AbpTextBoxControlComponent_ng_container_0_Template_input_keyup_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onKeyup($event.target.value); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "abp-validation-display", 5);
    ɵngcc0.ɵɵlistener("isControlValid", function AbpTextBoxControlComponent_ng_container_0_Template_abp_validation_display_isControlValid_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.setClassForControlValidity($event); });
    ɵngcc0.ɵɵpipe(6, "async");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate2("id", "div_abp_textbox_", ctx_r0.id, "_", ctx_r0.field.fieldCode, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", ctx_r0.displayLabelField);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ctx_r0.inputControlCss);
    ɵngcc0.ɵɵpropertyInterpolate2("id", "txt_abp_textbox_", ctx_r0.id, "_", ctx_r0.field.fieldCode, "");
    ɵngcc0.ɵɵpropertyInterpolate2("name", "txt_abp_textbox_", ctx_r0.id, "_", ctx_r0.field.fieldCode, "");
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.field.isDisabled)("value", ctx_r0.value);
    ɵngcc0.ɵɵattribute("placeholder", ctx_r0.field.placeHolder);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("control", ɵngcc0.ɵɵpipeBind1(6, 15, ctx_r0.control))("isSubmitted", ctx_r0.isFormSubmitted)("validationMap", ctx_r0.field.validationMap);
} }
const _c0 = function (a0) { return [a0, "icon-input"]; };
function AbpPasswordControlComponent_ng_container_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "input", 8, 9);
    ɵngcc0.ɵɵlistener("change", function AbpPasswordControlComponent_ng_container_0_ng_container_4_Template_input_change_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.onInputChange($event.target.value); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate2("id", "txt_abp_password_", ctx_r1.id, "_", ctx_r1.field.fieldCode, "");
    ɵngcc0.ɵɵpropertyInterpolate2("name", "txt_abp_password_", ctx_r1.id, "_", ctx_r1.field.fieldCode, "");
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(8, _c0, ctx_r1.inputControlCss))("disabled", ctx_r1.field.isDisabled)("value", ctx_r1.value);
    ɵngcc0.ɵɵattribute("placeholder", ctx_r1.field.placeHolder);
} }
function AbpPasswordControlComponent_ng_container_0_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 10, 9);
    ɵngcc0.ɵɵlistener("change", function AbpPasswordControlComponent_ng_container_0_ng_template_5_Template_input_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.onInputChange($event.target.value); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "txt_abp_password_", ctx_r3.field.fieldCode, "");
    ɵngcc0.ɵɵpropertyInterpolate1("name", "txt_abp_password_", ctx_r3.field.fieldCode, "");
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c0, ctx_r3.inputControlCss))("value", ctx_r3.value);
    ɵngcc0.ɵɵattribute("placeholder", ctx_r3.field.placeHolder);
} }
const _c1 = function (a0) { return [a0, "icon"]; };
function AbpPasswordControlComponent_ng_container_0_i_7_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 11);
    ɵngcc0.ɵɵlistener("click", function AbpPasswordControlComponent_ng_container_0_i_7_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.toggleTextBoxType(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "btn_abp_password_icon_", ctx_r4.field.fieldCode, "");
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c1, ctx_r4.iconClass));
} }
function AbpPasswordControlComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelement(2, "abp-field-display-label", 2);
    ɵngcc0.ɵɵelementStart(3, "div", 3);
    ɵngcc0.ɵɵtemplate(4, AbpPasswordControlComponent_ng_container_0_ng_container_4_Template, 3, 10, "ng-container", 4);
    ɵngcc0.ɵɵtemplate(5, AbpPasswordControlComponent_ng_container_0_ng_template_5_Template, 2, 7, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(7, AbpPasswordControlComponent_ng_container_0_i_7_Template, 1, 4, "i", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "abp-validation-display", 7);
    ɵngcc0.ɵɵlistener("isControlValid", function AbpPasswordControlComponent_ng_container_0_Template_abp_validation_display_isControlValid_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.setClassForControlValidity($event); });
    ɵngcc0.ɵɵpipe(9, "async");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r2 = ɵngcc0.ɵɵreference(6);
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate2("id", "div_abp_password_", ctx_r0.id, "_", ctx_r0.field.fieldCode, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", ctx_r0.displayLabelField);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.showText)("ngIfElse", _r2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.textConfig.hasShowIcon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("control", ɵngcc0.ɵɵpipeBind1(9, 9, ctx_r0.control))("isSubmitted", ctx_r0.isFormSubmitted)("validationMap", ctx_r0.field.validationMap);
} }
const _c2 = ".abp-input-control[_ngcontent-%COMP%]{display:block;width:100%;height:calc(1.5em + .75rem + 2px);font-size:1rem;font-weight:400;line-height:1.5;border-radius:.25rem;color:#495057;background-color:#fff;padding:.375rem .75rem;margin:0 0 2%;border:1px solid #ced4da}.abp-input-control[_ngcontent-%COMP%]:disabled{background-color:#e9ecef;opacity:1}.error[_ngcontent-%COMP%]{background-color:none;border-left-style:solid!important;border-left-color:#dc3545!important;border-left-width:thick!important}.valid[_ngcontent-%COMP%]{background-color:none;border-left-style:solid!important;border-left-color:#28a745!important;border-left-width:thick!important}.validation-msg[_ngcontent-%COMP%]{color:#dc3545!important}.abp-icon-input[_ngcontent-%COMP%]{display:flex}.abp-icon-input[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{margin-left:-38px;cursor:pointer;display:inline-flex;padding-top:.75rem}.abp-icon-input[_ngcontent-%COMP%]   .icon-input[_ngcontent-%COMP%]{display:inline-flex;width:98%!important}";
export { AbpTextFieldModel } from '@colibrium/abp-form-control-base';
import { AbpBaseConstant } from '@colibrium/abp-base';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AbpLabelConstant, AbpLabelModule } from '@colibrium/abp-label';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
class AbpTextBoxControlComponent extends ControlBase {
    //#region input properties
    //#endregion input properties
    //#region model properties
    //#endregion model properties
    //#region constructor
    /**
     * @param {?} config
     * @param {?} inj
     * @param {?} detector
     */
    constructor(config, inj, detector) {
        super(inj, config, detector);
    }
    //#endregion constructor
    //#region component events
    /**
     * @return {?}
     */
    ngOnInit() {
        this.onInitialization();
    }
    /**
     * @param {?} simpleChanges
     * @return {?}
     */
    ngOnChanges(simpleChanges) {
        this.onNgInputChanges(simpleChanges);
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.onViewInitialization();
    }
    /**
     * @return {?}
     */
    ngAfterViewChecked() {
    }
    //#endregion component events
    //#region service calls
    //#endregion service calls
    //#region public functions/events assoaciated with UI elements
    /**
     * on key up
     * @param {?} val
     * @return {?}
     */
    onKeyup(val) {
        this.setValueBase(val);
    }
}
AbpTextBoxControlComponent.ɵfac = function AbpTextBoxControlComponent_Factory(t) { return new (t || AbpTextBoxControlComponent)(ɵngcc0.ɵɵdirectiveInject(AbpValidationDisplayConstant.validationDisplayConfigInjectKey), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
AbpTextBoxControlComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AbpTextBoxControlComponent, selectors: [["abp-textbox"]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(( /**
                 * @return {?}
                 */() => AbpTextBoxControlComponent)),
                multi: true
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 3, consts: [[4, "ngIf"], [3, "id"], [3, "field"], ["type", "text", 3, "id", "name", "disabled", "value", "change", "keyup"], ["inputControlVariable", ""], [3, "control", "isSubmitted", "validationMap", "isControlValid"]], template: function AbpTextBoxControlComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, AbpTextBoxControlComponent_ng_container_0_Template, 7, 17, "ng-container", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.field.isVisible));
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.AbpFieldDisplayLabelComponent, ɵngcc3.AbpValidationDisplayComponent], pipes: [ɵngcc1.AsyncPipe], styles: [_c2], changeDetection: 0 });
/** @nocollapse */
AbpTextBoxControlComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [AbpValidationDisplayConstant.validationDisplayConfigInjectKey,] }] },
    { type: Injector },
    { type: ChangeDetectorRef }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbpTextBoxControlComponent, [{
        type: Component,
        args: [{
                selector: 'abp-textbox',
                template: "<ng-container *ngIf=\"field.isVisible|async\">\r\n  <div id=\"div_abp_textbox_{{id}}_{{field.fieldCode}}\">\r\n\r\n    <abp-field-display-label [field]=\"displayLabelField\"></abp-field-display-label>\r\n    <input type=\"text\"\r\n           id=\"txt_abp_textbox_{{id}}_{{field.fieldCode}}\"\r\n           name=\"txt_abp_textbox_{{id}}_{{field.fieldCode}}\"\r\n           [class]=\"inputControlCss\"\r\n           [attr.placeholder]=\"field.placeHolder\"\r\n           [disabled]=\"field.isDisabled\"\r\n           (change)=\"onInputChange($event.target.value)\"\r\n           (keyup)=\"onKeyup($event.target.value)\"\r\n           [value]=\"value\"\r\n           #inputControlVariable />\r\n    <abp-validation-display [control]=\"control|async\"\r\n                            [isSubmitted]=\"isFormSubmitted\"\r\n                            [validationMap]=\"field.validationMap\"\r\n                            (isControlValid)=\"setClassForControlValidity($event)\"></abp-validation-display>\r\n  </div>\r\n</ng-container>\r\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(( /**
                         * @return {?}
                         */() => AbpTextBoxControlComponent)),
                        multi: true
                    }
                ],
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".abp-input-control{display:block;width:100%;height:calc(1.5em + .75rem + 2px);font-size:1rem;font-weight:400;line-height:1.5;border-radius:.25rem;color:#495057;background-color:#fff;padding:.375rem .75rem;margin:0 0 2%;border:1px solid #ced4da}.abp-input-control:disabled{background-color:#e9ecef;opacity:1}.error{background-color:none;border-left-style:solid!important;border-left-color:#dc3545!important;border-left-width:thick!important}.valid{background-color:none;border-left-style:solid!important;border-left-color:#28a745!important;border-left-width:thick!important}.validation-msg{color:#dc3545!important}.abp-icon-input{display:flex}.abp-icon-input .icon{margin-left:-38px;cursor:pointer;display:inline-flex;padding-top:.75rem}.abp-icon-input .icon-input{display:inline-flex;width:98%!important}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [AbpValidationDisplayConstant.validationDisplayConfigInjectKey]
            }] }, { type: ɵngcc0.Injector }, { type: ɵngcc0.ChangeDetectorRef }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
class AbpTextboxConstant extends AbpBaseConstant {
}
AbpTextboxConstant.textboxConfigInjectKey = 'textbox-config';
if (false) {
    /** @type {?} */
    AbpTextboxConstant.textboxConfigInjectKey;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
class AbpPasswordControlComponent extends ControlBase {
    //#endregion model properties
    //#region constructor
    /**
     * @param {?} inj
     * @param {?} config
     * @param {?} textboxConfig
     * @param {?} detector
     */
    constructor(inj, config, textboxConfig, detector) {
        super(inj, config, detector);
        this.textboxConfig = textboxConfig;
        this.showText = false;
        this.textConfig = this.getConfigDefaults(textboxConfig);
    }
    //#endregion constructor
    //#region readonly properties
    /**
     * icon class to display
     * @return {?}
     */
    get iconClass() {
        return this.showText ? this.textConfig.onShowIcon : this.textConfig.onMaskIcon;
    }
    ;
    //#endregion readonly properties
    //#region component events
    /**
     * @return {?}
     */
    ngOnInit() {
        this.onInitialization();
    }
    /**
     * @param {?} simpleChanges
     * @return {?}
     */
    ngOnChanges(simpleChanges) {
        this.onNgInputChanges(simpleChanges);
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.onViewInitialization();
    }
    /**
     * @return {?}
     */
    ngAfterViewChecked() {
    }
    //#endregion component events
    //#region service calls
    //#endregion service calls
    //#region public functions/events assoaciated with UI elements
    /**
     * toggle the type value on button click
     * @return {?}
     */
    toggleTextBoxType() {
        this.showText = !this.showText;
    }
    //#endregion public functions/events assoaciated with UI elements
    //#region private functions
    /**
     * gets default values for configs
     * @private
     * @param {?} injectionModel
     * @return {?}
     */
    getConfigDefaults(injectionModel) {
        if (injectionModel) {
            return injectionModel;
        }
        /** @type {?} */
        let configData = {
            hasShowIcon: false
        };
        return configData;
    }
}
AbpPasswordControlComponent.ɵfac = function AbpPasswordControlComponent_Factory(t) { return new (t || AbpPasswordControlComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(AbpValidationDisplayConstant.validationDisplayConfigInjectKey, 8), ɵngcc0.ɵɵdirectiveInject(AbpTextboxConstant.textboxConfigInjectKey, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
AbpPasswordControlComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AbpPasswordControlComponent, selectors: [["abp-password"]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(( /**
                 * @return {?}
                 */() => AbpPasswordControlComponent)),
                multi: true
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 3, consts: [[4, "ngIf"], [3, "id"], [3, "field"], [1, "abp-icon-input"], [4, "ngIf", "ngIfElse"], ["textInput", ""], ["aria-hidden", "true", 3, "id", "ngClass", "click", 4, "ngIf"], [3, "control", "isSubmitted", "validationMap", "isControlValid"], ["type", "password", 3, "id", "name", "ngClass", "disabled", "value", "change"], ["inputControlVariable", ""], ["type", "text", 3, "id", "name", "ngClass", "value", "change"], ["aria-hidden", "true", 3, "id", "ngClass", "click"]], template: function AbpPasswordControlComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, AbpPasswordControlComponent_ng_container_0_Template, 10, 11, "ng-container", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.field.isVisible));
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.AbpFieldDisplayLabelComponent, ɵngcc3.AbpValidationDisplayComponent, ɵngcc1.NgClass], pipes: [ɵngcc1.AsyncPipe], styles: [_c2], changeDetection: 0 });
/** @nocollapse */
AbpPasswordControlComponent.ctorParameters = () => [
    { type: Injector },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [AbpValidationDisplayConstant.validationDisplayConfigInjectKey,] }] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [AbpTextboxConstant.textboxConfigInjectKey,] }] },
    { type: ChangeDetectorRef }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbpPasswordControlComponent, [{
        type: Component,
        args: [{
                selector: 'abp-password',
                template: "<ng-container *ngIf=\"field.isVisible|async\">\r\n  <div id=\"div_abp_password_{{id}}_{{field.fieldCode}}\">\r\n\r\n    <abp-field-display-label [field]=\"displayLabelField\"></abp-field-display-label>\r\n\r\n    <div class=\"abp-icon-input\">\r\n\r\n      <ng-container *ngIf=\"!showText; else textInput\">\r\n        <input type=\"password\"\r\n               id=\"txt_abp_password_{{id}}_{{field.fieldCode}}\"\r\n               name=\"txt_abp_password_{{id}}_{{field.fieldCode}}\"\r\n               [ngClass]=\"[inputControlCss, 'icon-input']\"\r\n               [attr.placeholder]=\"field.placeHolder\"\r\n               [disabled]=\"field.isDisabled\"\r\n               (change)=\"onInputChange($event.target.value)\"\r\n               [value]=\"value\"\r\n               #inputControlVariable />\r\n      </ng-container>\r\n      <ng-template #textInput>\r\n        <input type=\"text\"\r\n               id=\"txt_abp_password_{{field.fieldCode}}\"\r\n               name=\"txt_abp_password_{{field.fieldCode}}\"\r\n               [ngClass]=\"[inputControlCss, 'icon-input']\"\r\n               [attr.placeholder]=\"field.placeHolder\"\r\n               (change)=\"onInputChange($event.target.value)\"\r\n               [value]=\"value\"\r\n               #inputControlVariable />\r\n      </ng-template>\r\n\r\n      <i id=\"btn_abp_password_icon_{{field.fieldCode}}\"\r\n         *ngIf=\"textConfig.hasShowIcon\"\r\n         [ngClass]=\"[iconClass, 'icon']\"\r\n         aria-hidden=\"true\"\r\n         (click)=\"toggleTextBoxType()\">\r\n      </i>\r\n\r\n    </div>\r\n\r\n    <abp-validation-display [control]=\"control|async\"\r\n                            [isSubmitted]=\"isFormSubmitted\"\r\n                            [validationMap]=\"field.validationMap\"\r\n                            (isControlValid)=\"setClassForControlValidity($event)\"></abp-validation-display>\r\n  </div>\r\n</ng-container>\r\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(( /**
                         * @return {?}
                         */() => AbpPasswordControlComponent)),
                        multi: true
                    }
                ],
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".abp-input-control{display:block;width:100%;height:calc(1.5em + .75rem + 2px);font-size:1rem;font-weight:400;line-height:1.5;border-radius:.25rem;color:#495057;background-color:#fff;padding:.375rem .75rem;margin:0 0 2%;border:1px solid #ced4da}.abp-input-control:disabled{background-color:#e9ecef;opacity:1}.error{background-color:none;border-left-style:solid!important;border-left-color:#dc3545!important;border-left-width:thick!important}.valid{background-color:none;border-left-style:solid!important;border-left-color:#28a745!important;border-left-width:thick!important}.validation-msg{color:#dc3545!important}.abp-icon-input{display:flex}.abp-icon-input .icon{margin-left:-38px;cursor:pointer;display:inline-flex;padding-top:.75rem}.abp-icon-input .icon-input{display:inline-flex;width:98%!important}"]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [AbpValidationDisplayConstant.validationDisplayConfigInjectKey]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [AbpTextboxConstant.textboxConfigInjectKey]
            }] }, { type: ɵngcc0.ChangeDetectorRef }]; }, null); })();
if (false) {
    /** @type {?} */
    AbpPasswordControlComponent.prototype.textConfig;
    /** @type {?} */
    AbpPasswordControlComponent.prototype.showText;
    /**
     * @type {?}
     * @private
     */
    AbpPasswordControlComponent.prototype.textboxConfig;
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#region angular imports
//#endregion angular imports
//#region core imports
//#endregion core imports
//#region functional/model imports
//#endregion functional/model imports
/**
 * @record
 */
function AbpTextboxConfigModel() { }
if (false) {
    /** @type {?|undefined} */
    AbpTextboxConfigModel.prototype.hasShowIcon;
    /** @type {?|undefined} */
    AbpTextboxConfigModel.prototype.onMaskIcon;
    /** @type {?|undefined} */
    AbpTextboxConfigModel.prototype.onShowIcon;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AbpTextboxModule {
    /**
     * @param {?} textConfig
     * @param {?} validationConfig
     * @param {?} labelConfig
     * @return {?}
     */
    static forRoot(textConfig, validationConfig, labelConfig) {
        return (/** @type {?} */ ({
            ngModule: AbpTextboxModule,
            providers: [
                { provide: AbpTextboxConstant.textboxConfigInjectKey, useValue: textConfig },
                { provide: AbpValidationDisplayConstant.validationDisplayConfigInjectKey, useValue: validationConfig },
                { provide: AbpLabelConstant.labelConfigInjectKey, useValue: labelConfig }
            ]
        }));
    }
}
AbpTextboxModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AbpTextboxModule });
AbpTextboxModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AbpTextboxModule_Factory(t) { return new (t || AbpTextboxModule)(); }, imports: [[
            CommonModule,
            RouterModule,
            AbpValidationDisplayModule,
            AbpLabelModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AbpTextboxModule, { declarations: function () { return [AbpTextBoxControlComponent, AbpPasswordControlComponent]; }, imports: function () { return [CommonModule,
        RouterModule,
        AbpValidationDisplayModule,
        AbpLabelModule]; }, exports: function () { return [AbpTextBoxControlComponent, AbpPasswordControlComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbpTextboxModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    RouterModule,
                    AbpValidationDisplayModule,
                    AbpLabelModule
                ],
                declarations: [
                    AbpTextBoxControlComponent,
                    AbpPasswordControlComponent
                ],
                exports: [
                    AbpTextBoxControlComponent,
                    AbpPasswordControlComponent
                ],
                entryComponents: [
                    AbpTextBoxControlComponent,
                    AbpPasswordControlComponent
                ]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AbpPasswordControlComponent, AbpTextBoxControlComponent, AbpTextboxConstant, AbpTextboxModule };

//# sourceMappingURL=colibrium-abp-textbox.js.map